<script setup lang="ts">
import {getFileName} from '~/helpers/baseFunction';
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useLocale} from '~/plugins/Localization';
import ModalForOpen from './ModalForOpen.vue';
import {useDirectionStore} from '~/store/direction.store';
import Logger from "~/helpers/logger";

const logger = Logger.getInstance();
let isBeta: boolean;
const route = useRoute();
const locale = useLocale();

const nameFlats = computed(() => route.query.tetriaryRouteName);
const nameRC = computed(() => route.query.nameRC);

const isOpenRedirect = ref(false);

const array = computed(() =>
  (route.query.dfdSaves || []).filter((e) =>
    e.toLowerCase().endsWith('.jpeg'),
  ),
);

const direction = useDirectionStore();
const isRight = ref(direction.$state.isRight);

direction.$subscribe((_, state) => {
  isRight.value = state.isRight;
});

const modal = ref<InstanceType<typeof ModalForOpen> | null>(null);

const toTranslate = (val: string, saveTranslatedName: any) => {
  const tr = locale.getRealty(`${route.query.nameRC}_${val}`);
  if (!tr.includes('_No_translated')) {
    return tr;
  } else return saveTranslatedName;
};

var selectedSave: any;
const openRoom = async (save: any) => {
  const getUUid = selectedSave?.split('apartment/')[1]?.split('/')[0];
  const fileName = getFileName(selectedSave);
  const url = `df-launcher${
    isBeta ? '-beta' : ''
  }://open_realty_save?jwt=${
    useCookie('df').value
  }&uuidApartament=${getUUid}&saveName=${
    fileName.filenameWithoutExtension
  }&nameRC=${nameRC.value}`;

  location.href = url;
  modal.value?.closeHandler();
};
const openModal = (save: any) => {
  logger.info('[EVENT] click button openModal()');
  selectedSave = save;
  modal.value?.open();
};
const option = {
  callback: openRoom,
  message: 'openLauncherForSave',
  message_sub: 'openLauncherForSave_sub',
  secondBtn: 'openLauncher',
};
const view = ref(false);
onMounted(async () => {
  isBeta =
    location.href.includes('work') ||
    location.href.includes('localhost') ||
    location.href.includes('127.0.0.1');
  view.value = true;
});
</script>

<template>
  <section :class="['dfdSaves-wrapper']" v-if="view">
    <div v-for="save in array" :key="save" class="dfdSaves-card">
      <div class="preview-demo-flats">
        <img class="image" :src="save" />
      </div>
      <div :class="['title', {right: isRight}]">
        {{
          toTranslate(
            getFileName(save).filenameWithoutExtension,
            nameFlats,
          )
        }}
      </div>
      <div class="action">
        <ui-button
          class="btn"
          :label="$t('open')"
          color="gray"
          :size="ButtonSizeType.big"
          @click="openModal(save)"
        />
      </div>
    </div>
  </section>
  <modal-for-open ref="modal" :options="option" />
</template>

<style scoped lang="scss">
.dfdSaves-wrapper {
  width: 100%;
  max-width: 1128px;
  min-height: 576px;
  margin: 0 auto 0;
  @include grid-card-center;
  .dfdSaves-card {
    width: 264px;
    height: fit-content;
    padding: 18px;
    border-radius: 16px;
    border: 1px solid var(--white-theme-white-400, #e1e5f0);
    background: var(--white-theme-white-200, #f6f8fd);
    display: flex;
    flex-direction: column;

    .action {
      width: 100%;
      margin-top: $mt-4;

      .btn {
        width: 100%;
      }
    }
    .preview-demo-flats {
      height: 127px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        border-radius: 12px;
        width: 100%;
      }
    }
    .title {
      color: var(--white-theme-black-100, #3d424a);
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.32px;
      align-items: center;
      position: relative;
      display: flex;
      white-space: nowrap;
      overflow: hidden;
      &.right {
        &::after {
          right: 0;
          background: linear-gradient(
            90deg,
            #f6f8fd 10%,
            transparent 30%
          );
          content: '';
          height: 20px;
          position: absolute;
          pointer-events: none;
          width: 100%;
          z-index: 2;
        }
      }
      &::after {
        right: 0;
        background: linear-gradient(
          270deg,
          #f6f8fd 10%,
          transparent 30%
        );
        content: '';
        height: 20px;
        position: absolute;
        pointer-events: none;
        width: 100%;
        z-index: 2;
      }
    }
  }
}
</style>
